// extracted by mini-css-extract-plugin
export default {"invalid":"PermisosEdit_invalid__YZuHz","spinnerContainer":"PermisosEdit_spinnerContainer__7m5lt"};